import template from './template.html';
import './styles.css';

controller.$inject = ['$stateParams'];

export function controller($stateParams) {
    var vm = this;
    vm.shifts = shifts;
    vm.week = $stateParams.week;
    vm.date = $stateParams.date;
    vm.isDriverHoliday = isDriverHoliday;

    function shifts() {
        if (vm.date && vm.data && vm.data.constructor === Array) {
            return vm.data.reduce((prev, curr) => {
                const days = curr.days.filter(d => compareDate(d.shiftDate, vm.date));
                return [...prev, ...days];
            }, []);
        }
    }

    function isDriverHoliday() {
        if (!vm.holidays || vm.holidays.constructor !== Array) return false;
        
        for (var i = 0; i < vm.holidays.length; i++) {
            if (compareDate(vm.date, vm.holidays[i].day)) {
                return true;
            }
        }
        return false;
    }

    function compareDate(d1, d2) {
        const date1 = new Date(d1);
        date1.setHours(0, 0, 0, 0);
        const date2 = new Date(d2);
        date2.setHours(0, 0, 0, 0);

        return date1.getTime() === date2.getTime();
    }
}

export default () => ({
    template,
    controller,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: {
        data: '=',
        holidays: '='
    },
    scope: {}
});



// WEBPACK FOOTER //
// ./src/js/components/planner/dailyview/index.js